export const DoppeActionTypeSubscribeViewerLang = {
    defaultTexts: {
        subscribeButtonText: 'Subscribe'
    }
}